module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\">{{ initials }}</div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/banner/template.html
// module id = ../node_modules/xo-ui-components/src/banner/template.html
// module chunks = 0